<template>
  <div>
    <div class="M_H topBtn">
      <el-button type="warning" size="mini" @click="saveData">提 交</el-button>
<!--      <el-button :disabled="btnShow" type="warning" size="mini"  @click="intoStrockSureV4()"-->
<!--      >入库确认</el-button-->
<!--      >-->
<!--      <el-button :disabled="btnShow" type="warning" size="mini"  @click="cancelIntoStrockSureV4()"-->
<!--      >取消入库确认</el-button-->
<!--      >-->
<!--      <el-button :disabled="btnShow" type="warning" size="mini"  @click="pushIntoStrockCheckScale()"-->
<!--      >推送复测</el-button-->
<!--      >-->
    </div>
    <div class="form-line"></div>
    <div class="tag-container" >
      <div class="tag-searchWaybill" >
        <span>查询运单号/快递单号：</span>
        <el-input
            class="jy-form-input"
            v-model="searchWaybillNumber"
            placeholder="请输入运单号/快递单号"
            clearable
            @keyup.enter.native="onSearchWaybillNumber"
        ></el-input>
        <el-button  style="background-color: #FF9900; color: white;" @click="onSearchWaybillNumber">查询</el-button>
      </div>

    </div>


    <div class="billHeader">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="header-item">
            <span class="label">运单号：</span>
            <span class="value">{{ applyPackInfo.waybillNumber }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="header-item">
            <span class="label">快递单号：</span>
            <span class="value">{{ newForm.courierNumber }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="title-area">
            <h2>入库单</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="header-item">
            <span class="label">客户名称：</span>
            <span class="value">{{ newForm.nickname }} ({{ newForm.memberId }})</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="header-item">
            <span class="label">入库时间：</span>
            <el-date-picker
                v-model="applyPackInfo.intoStorageTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"            style="width: 100%"
            ></el-date-picker>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="mainBox">
      <div class="newForm">
        <el-form
            ref="newForm"
            :model="newForm"
            label-width="100px"
        >
          <!-- 基础信息 -->
          <div class="M" style="margin-bottom: 10px">
            <div class="inlineDiv">
              <div class="queryItem1">
                <el-form-item label="数据确认类型:" prop="isCustomerCheckScale" class="custom-form-item">
                  <el-select
                      v-model="applyPackInfo.isCustomerCheckScale"
                      clearable
                      placeholder="请选择确认类型"
                  >
                    <el-option
                        v-for="(item, index) in isCustomerCheckScaleList"
                        :label="item.label"
                        :key="item.value"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="queryItem1">
                <el-form-item label="入仓仓库:" prop="storageId" class="custom-form-item">
                  <el-select
                      filterable
                      clearable
                      v-model="newForm.storageId"
                      placeholder="请选择仓库"
                  >
                    <el-option
                        v-for="(item, index) in cangkuList"
                        :label="item.storageName"
                        :value="item.id"
                        :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="inlineDiv">
              <div class="queryItem1" style="width: 94%">
                <el-form-item label="入库备注:" prop="comment" class="custom-form-item">
                  <el-input
                      clearable
                      type="textarea"
                      rows="1"
                      v-model="applyPackInfo.comment"
                      placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="M_tabel">
              <div class="inlineDiv">货物信息: </div>
              <el-table
                  border
                  :data="newForm.itemReqs"
                  size="small"
                  style="width: 100%; margin-top: 10px;"
                  @row-click="handleRowClick"
                  :row-class-name="highlightRowClassName"
                  :header-cell-style="{ background: '#f0f0f0' }"
              >
                <el-table-column
                    fixed="left"
                    align="center"
                    label="序号"
                    type="index"
                    width="40"
                ></el-table-column>

                <el-table-column align="center" prop="boxNo" label="箱号" width="100">
                  <template slot-scope="scope">
                    <el-input
                        class="myInputs"
                        v-model="newForm.itemReqs[scope.$index].boxNo"
                        placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="shippingMarkNo" label="唛头" width="100">
                  <template slot-scope="scope">
                    <el-input
                        class="myInputs"
                        v-model="newForm.itemReqs[scope.$index].shippingMarkNo"
                        placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="itemName"
                    label="品名"
                    align="center"
                    min-width="200px"
                >
                  <template slot-scope="scope">
                    <el-select
                        v-model="newForm.itemReqs[scope.$index].itemNameCode"
                        filterable
                        clearable
                        size="mini"
                        allow-create
                        placeholder="请选择或输入"
                        @change="changeItem($event, scope.$index)"
                    >
                      <el-option
                          v-for="(item, index) in itemNameList"
                          :key="index"
                          :value="item.itemNameCode"
                          :label="item.showName"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                        class="myInputs"
                        v-if="!newForm.itemReqs[scope.$index].itemNameCode"
                        v-model="newForm.itemReqs[scope.$index].itemName"
                        placeholder="自定义品名"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="unitPrice"
                    min-width="100px"
                    align="center"
                    label="单价"
                >
                  <template slot-scope="scope">
                    <el-input
                        disabled
                        size="mini"
                        placeholder="请输入单价"
                        v-model="newForm.itemReqs[scope.$index].unitPrice"
                    >
                    </el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    prop="quantity"
                    min-width="100px"
                    align="center"
                    label="件数"
                >
                  <template slot-scope="scope">
                    <el-input
                        disabled
                        size="mini"
                        type="number"
                        placeholder="请输入件数"
                        v-model="newForm.itemReqs[scope.$index].quantity"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="intoStorageCount"
                    min-width="100px"
                    align="center"
                    label="入库件数"
                >
                  <template slot-scope="scope">
                    <el-input
                        size="mini"
                        type="number"
                        placeholder="请输入入库件数"
                        v-model="newForm.itemReqs[scope.$index].intoStorageCount"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="weight"
                    min-width="100px"
                    align="center"
                    label="重量(kg)"
                >
                  <template slot-scope="scope">
                    <el-input
                        disabled
                        size="mini"
                        type="number"
                        placeholder="请输入"
                        v-model="newForm.itemReqs[scope.$index].weight"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="intoStorageWeight"
                    min-width="100px"
                    align="center"
                    label="入库重量(kg)"
                >
                  <template slot-scope="scope">
                    <el-input
                        size="mini"
                        type="number"
                        placeholder="请输入入库重量"
                        v-model="newForm.itemReqs[scope.$index].intoStorageWeight"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="volume"
                    min-width="200px"
                    align="center"
                    label="体积(m³)"
                >
                  <template slot-scope="scope">
                    <div class="wtl_displayFlex">
                      <el-input
                          disabled
                          size="mini"
                          type="number"
                          clearable
                          placeholder="请输入"
                          v-model="newForm.itemReqs[scope.$index].volume"
                      >
                      </el-input>
                      <!-- <i style="margin-left: 10px" class="el-icon-menu"></i> -->

                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="intoStorageVolume"
                    min-width="130px"
                    align="center"
                    label="入库体积(m³)"
                >
                  <template slot-scope="scope">
                    <div class="wtl_displayFlex">
                      <el-input
                          size="mini"
                          type="number"
                          clearable
                          placeholder="请输入"
                          v-model="newForm.itemReqs[scope.$index].intoStorageVolume"
                      >
                      </el-input>
                      <div
                          class="totBtns"
                          @click="totleVolume(scope.$index, scope.row)"
                      >
                        计算
                      </div>
                      <!-- <i style="margin-left: 10px" class="el-icon-menu"></i> -->
                      <!--                  <div-->
                      <!--                      class="totBtns"-->
                      <!--                      @click="totleVolume(scope.$index, scope.row)"-->
                      <!--                  >-->
                      <!--                    计算-->
                      <!--                  </div>-->
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="intoStorageSettlementWeight"
                    min-width="100px"
                    align="center"
                    label="结算重量"
                >
                  <template slot-scope="scope">
                    <el-input
                        size="mini"
                        type="number"
                        placeholder="请输入结算重量"
                        v-model="newForm.itemReqs[scope.$index].intoStorageSettlementWeight"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="intoStorageSettlementVolume"
                    min-width="100px"
                    align="center"
                    label="结算体积"
                >
                  <template slot-scope="scope">
                    <el-input
                        size="mini"
                        type="number"
                        placeholder="请输入结算体积"
                        v-model="newForm.itemReqs[scope.$index].intoStorageSettlementVolume"
                    >
                    </el-input>
                  </template>
                </el-table-column>



                <el-table-column
                    align="center"
                    prop="specs"
                    label="规格汇总"
                    width="180"
                >
                  <template slot-scope="scope">
                    <el-input
                        type="textarea"
                        autosize
                        v-model="newForm.itemReqs[scope.$index].specs"
                        @focus="isSpecsAutoUpdate = false"
                        @blur="isSpecsAutoUpdate = true"
                        placeholder="请输入"
                    >
                    </el-input>
                  </template>
                </el-table-column>

<!--                <el-table-column label="操作" align="center" fixed="right" width="120">-->
<!--                  <template slot-scope="scope">-->
<!--                    <div v-if="scope.$index === 0">-->
<!--                      <el-button @click="addbtn(scope.$index)" size="mini"-->
<!--                      >新增</el-button-->
<!--                      >-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                      <el-button @click="delbut(scope.$index)" size="mini"-->
<!--                      >删除</el-button-->
<!--                      >-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </el-table-column>-->
              </el-table>
            </div>
            <!-- 规格信息（由货物信息带动更新） -->
            <el-card
                shadow="never"
                class="M"
            >
              <el-form class="M_tabel">
                <el-row>
                  <el-col :span="23" class="jy-card-details">
                    <div class="button-ground" >
                      <el-button
                          size="large"
                          plain
                          class="jy-button"
                          @click="onInputSpecifications(1)"
                      >规格替换填充↓</el-button
                      >
                      <el-button
                          size="large"
                          plain
                          class="jy-button"
                          @click="onInputSpecifications(2)"
                      >规格追加填充↓</el-button
                      >
                      <el-button
                          size="large"
                          plain
                          class="jy-button"
                          @click="onComputeSpecifications"
                      >规格汇总↑</el-button
                      >
                      <el-button
                          size="large"
                          plain
                          class="jy-button"
                          @click="seeAllSpecs"
                      >查看全部规格</el-button
                      >
                      <el-button
                          size="large"
                          plain
                          class="jy-button"
                          @click="delSpecsMore"
                          v-if="this.selectedItemIndex !== -1"
                      >移除规格</el-button
                      >
                    </div>


                    <div
                        class="table-ground"
                        :style="'margin-top: 20px'"
                    >
                      <el-table
                          ref="mytable"
                          header-align="center"
                          border
                          stripe
                          style="width: 100%"
                          :data="selectedItemIndex === -1 ? allSpecifications : (selectionGargoInformationRow ? selectionGargoInformationRow.itemSpecs : [])"
                          :header-cell-style="{ background: '#f0f0f0' }"
                          :row-class-name="(index) => index === selectedItemIndex ? 'highlight-row' : ''"
                      >
                        <el-table-column type="selection" width="30" align="center"></el-table-column>
                        <el-table-column
                            fixed="left"
                            align="center"
                            label="序号"
                            type="index"
                            width="60"
                        ></el-table-column>
                        <el-table-column align="center" prop="goodsName" label="品名">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  disabled
                                  size="mini"
                                  v-model="scope.row.goodsName"
                                  placeholder=""
                              ></el-input>
                            </div>
                          </template>
                        </el-table-column>

                        <el-table-column align="center" prop="goodsLength" label="长cm">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  size="mini"
                                  type="number"
                                  v-model="scope.row.goodsLength"
                                  placeholder="请输入"
                                  @input="onComputeSpecsParameter(scope.row, scope.$index)"
                              ></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="goodsWide" label="宽cm">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  size="mini"
                                  type="number"
                                  v-model="scope.row.goodsWide"
                                  placeholder="请输入"
                                  @input="onComputeSpecsParameter(scope.row, scope.$index)"
                              ></el-input>
                            </div>
                          </template>

                        </el-table-column>
                        <el-table-column align="center" prop="goodsHeight" label="高cm">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  size="mini"
                                  type="number"
                                  v-model="scope.row.goodsHeight"
                                  placeholder="请输入"
                                  @input="onComputeSpecsParameter(scope.row, scope.$index)"
                              ></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="packageCount" label="件数">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  size="mini"
                                  type="number"
                                  v-model="scope.row.packageCount"
                                  placeholder="请输入"
                                  @input="onComputeSpecsParameter(scope.row, scope.$index)"
                              ></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="weight" label="入库重量">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  size="mini"
                                  type="number"
                                  v-model="scope.row.weight"
                                  placeholder="请输入"
                              ></el-input>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="volume" label="入仓体积/m³" width="200">
                          <template slot-scope="scope">
                            <div class="wtl_displayFlex">
                              <el-input
                                  size="mini"
                                  type="number"
                                  v-model="scope.row.volume"
                                  placeholder="请输入"
                              >

                              </el-input>
                              <div
                                  class="totBtns"
                                  @click="onComputeSpecsParameter(scope.row, scope.$index)"
                              >
                                计算
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="f99"
                            label="操作"
                            fixed="right"
                            width="200"
                        >
                          <template slot-scope="scope">
                            <div class="rowflexbox">
                              <el-button
                                  link
                                  v-if="selectedItemIndex !== -1 && (
                        selectionGargoInformationRow
                          ? selectionGargoInformationRow.itemSpecs
                              .length ===
                            scope.$index + 1
                          : false)
                      "
                                  @click="onAddSpecsList"
                                  size="mini"
                                  style="padding: 7px 10px; font-size: 12px;"
                              >增加</el-button
                              >
                              <el-popconfirm
                                  v-if="selectedItemIndex !== -1 "
                                  title="确定移除该行吗"
                                  @confirm="onDelSpecsList(scope.$index)"
                                  size="mini"
                              >
                                <template #reference>
                                  <el-button style="padding: 7px 10px; font-size: 12px;" link>移除</el-button>
                                </template>
                              </el-popconfirm>
                              <el-button
                                  v-if="selectedItemIndex !== -1 "
                                  size="mini"
                                  link
                                  @click="onCopySpecsList(scope.$index, scope)"
                                  style="padding: 7px 10px; font-size: 12px;"
                              >复制</el-button
                              >
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
          </div>
        </el-form>

      </div>

      <div class="M newForm">
        <AngleDouble title="附件信息">
          <commonFuJian ref="domCommonFuJian" :data = "annexTable"></commonFuJian>

        </AngleDouble>
      </div>
    </div>

  </div>
</template>

<script>
import { Api } from "@/assets/js/api";
import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import MathNumBer from "@/assets/js/MathNumBer";
import commonFuJian from "@/components/fuJian/index.vue";
// 详情页排版通用组件
import AngleDouble from '@/components/details/angleDouble.vue';
// 省市区数据
// import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  components: {
    AngleDouble,
    commonFuJian,
    paging
  },
  inject: ["reload"],
  data() {
    return {
      errorIndex: -1,
      selectedItemIndex: -1, // 当前选中的货物索引，默认-1表示未选择任何项
      selectionGargoInformationRow: null, // 当前选中行的货物信息
      allSpecifications: [], //所有的规格
      cutting: "", //批量添加要切割的字符串
      searchWaybillNumber: "",
      pageType: "add",
      intoStockId: "",
      itemNameList: [],
      memberNickname: "",
      //    ------------ new ------------
      activeName: "first", //  tab标识
      newForm: {
        courierNumber: "",
        memberId: "",
        storageId: "",
        itemReqs: [
          //物品数据
          {
            billItemId: "",
            operationType : "UPDATE",
            itemId: "", //  序号
            serialNumber: 1, //  序号
            boxNo: "", //  箱号
            shippingMarkNo: "", //  唛头
            itemNameCode: "", //  物品名
            itemName: "", //  物品名称
            unitPrice: "", //  单价
            quantity: 1, //  数量
            intoStorageCount: 0, //  入库件数
            weight: "", //重量
            intoStorageWeight: "", //入库重量
            volume: "", //体积
            intoStorageVolume: "", //入库体积
            intoStorageSettlementWeight: "",
            intoStorageSettlementVolume: "",
            specs: "", //规格汇总
            itemSpecs:[
              {
                operationType : "UPDATE",
                specsId: "",
                serialNumber: 1, //  序号
                packageCount: 1, //  件数
                goodsLength: "", //  长(cm)
                goodsWide: "", //  宽(cm)
                goodsHeight: "", //  高(cm)
                volume: "", //  体积
                weight: ""
              }
            ]
          },
        ],

        //  包裹预报表单数据
        packageId: "",
        nickname: "",
      },
      oldItemReqs: [
        //物品数据
        {
          billItemId: "",
          operationType : "UPDATE",
          itemId: "", //  序号
          serialNumber: 1, //  序号
          boxNo: "", //  箱号
          shippingMarkNo: "", //  唛头
          itemNameCode: "", //  物品名
          itemName: "", //  物品名称
          unitPrice: "", //  单价
          quantity: 1, //  数量
          intoStorageCount: 0, //  入库件数
          weight: "", //重量
          intoStorageWeight: "", //入库重量
          volume: "", //体积
          intoStorageVolume: "", //入库体积
          specs: "", //规格汇总
          intoStorageSettlementWeight: "",
          intoStorageSettlementVolume: "",
          itemSpecs:[
            {
              operationType : "UPDATE",
              specsId: "",
              serialNumber: 1, //  序号
              packageCount: 1, //  件数
              goodsLength: "", //  长(cm)
              goodsWide: "", //  宽(cm)
              goodsHeight: "", //  高(cm)
              volume: "", //  体积
              weight: ""
            }
          ]
        },
      ],
      annexTable: [],
      fileNames: [],
      cangkuList: [], //  仓库列表
      pageNum: 1,
      total: 0,
      size: 20,
      sizeList: [10, 20, 50, 100, 200],
      isJunp: false, //  页面是否要跳转标识
      form: {
        name: "",
        delivery: false,
      },
      packageId: "",
      billPackId: "",

      //  上传配置
      limitCount: 10,
      fileList: [],
      activeUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      pageStyle: "",
      // 入库单信息
      applyPackInfo: {
        billPackId: "",
        intoStorageTime:  "", //入库时间
        waybillNumber: "", //运单号
        isCustomerCheckScale: 0, //数据确认类型
        customerNumber: "", //客户单号
        withholdStatus: 0, //等通知放货
        comment:"",
      },
      isCustomerCheckScaleList: [
        {
          value: 0,
          label: "仓库确认",
        },
        {
          value: 1,
          label: "客户确认",
        },
      ],
      withholdStatusList: [
        {
          value: 0,
          label: "放货",
        },
        {
          value: 1,
          label: "扣货",
        },
      ],
      isSpecsAutoUpdate: true, // 控制是否自动更新规格汇总
    };
  },
  watch: {
    "newForm.itemReqs": {
      handler(val) {
        let specs = [];
        val.forEach(item => {
          if (item.itemSpecs && item.itemSpecs.length > 0) {
            item.itemSpecs.forEach(spec => {
              spec.goodsName = item.itemName; // 同步更新 goodsName

              // 过滤掉所有字段都为空的规格
              const { goodsLength, goodsWide, goodsHeight, packageCount, volume } = spec;
              const hasValue = [goodsLength, goodsWide, goodsHeight, packageCount, volume].some(
                  field => field !== null && field !== undefined && field !== ""
              );

              if (hasValue) {
                specs.push(spec);
              }
            });
          }
          // 只在规格明细变化时更新规格汇总，而不是每次都更新
          if(this.isSpecsAutoUpdate) {
            this.updateSpecsForSelectedItem(item);
          }
          // this.updateSpecsForSelectedItem(item); // 删除后更新 specs
        });
        this.allSpecifications = specs;
      },
      deep: true,
      immediate: true
    }
    // "newForm.itemReqs": {
    //   handler(a, b) {
    //     console.log(a);
    //   },
    //   deep: true,
    // },
  },
  created() {
    this.myGetStorageListPage(); //  获取仓库下拉列表
    this.NoHuoMao = tools.NoHuoMao();
  },
  activated() {
    // //初始化
    // this.applyPackInfo = {
    //   billPackId: "",
    //   intoStorageTime:  "", //入库时间
    //   waybillNumber: "", //运单号
    //   isCustomerCheckScale: 0, //数据确认类型
    //   customerNumber: "", //客户单号
    //   withholdStatus: 0, //等通知放货
    //   comment:"",
    // };
    // this.newForm = {
    //   courierNumber: "",
    //   memberId: "",
    //   storageId: "",
    //   itemReqs: [
    //     //物品数据
    //     {
    //       billItemId: "",
    //       operationType : "UPDATE",
    //       itemId: "", //  序号
    //       serialNumber: 1, //  序号
    //       boxNo: "", //  箱号
    //       shippingMarkNo: "", //  唛头
    //       itemNameCode: "", //  物品名
    //       itemName: "", //  物品名称
    //       unitPrice: "", //  单价
    //       quantity: 1, //  数量
    //       intoStorageCount: 0, //  入库件数
    //       weight: "", //重量
    //       intoStorageWeight: "", //入库重量
    //       volume: "", //体积
    //       intoStorageVolume: "", //入库体积
    //       intoStorageSettlementWeight: "",
    //       intoStorageSettlementVolume: "",
    //       specs: "", //规格汇总
    //       itemSpecs:[
    //         {
    //           operationType : "UPDATE",
    //           specsId: "",
    //           serialNumber: 1, //  序号
    //           packageCount: 1, //  件数
    //           goodsLength: "", //  长(cm)
    //           goodsWide: "", //  宽(cm)
    //           goodsHeight: "", //  高(cm)
    //           volume: "", //  体积
    //         }
    //       ]
    //     },
    //   ],
    // }
    // this.annexTable = [];
  },
  mounted() {
  },
  methods: {
    //  ----------- 图片上传 start--------------
    // 上传图片
    uploadSectionFile(param) {
      const file = param.file;
      const fileName = file.name;
      const form = new FormData(); // 根据后台需求数据格式
      form.append("file", file); // 文件对象
      form.append("fileName", fileName); // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      let signArr = [
        {
          key: "fileName",
          val: fileName,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      form.append("sign", sign);
      Api.uploadFile(form).then((res) => {
        if (res.data.status === "success") {
          this.fileList.push({
            name: res.data.result.fileName,
            uid: res.data.result.redirectUrl,
            url: res.data.result.url,
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //  图片上传事件
    handleRemove(file, fileList) {
      /* 移除图片 */
      this.fileList = fileList;
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //  ----------- 图片上传  end--------------
    // 入库信息参数计算
    onComputeSpecsParameter (row, index){
      let h = parseFloat(row.goodsHeight);
      let w = parseFloat(row.goodsWide);
      let l = parseFloat(row.goodsLength);
      let c = parseFloat(row.packageCount);
      if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) {
        // this.$message.warning('长或宽或高或件数不能留空，也不能是非数字');
        return;
      } else {
        this.selectionGargoInformationRow.itemSpecs[index].volume = (
            (h * w * l * c) /
            1000000
        ).toFixed(3);
      }
    },

    totleVolume(idx, row) {
      let arr = this.selectionGargoInformationRow.itemSpecs;
      for (let i = 0; i < arr.length; i++) {
        const value = arr[i];
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) {
          this.$message.warning('规格长或宽或高或件数不能留空，也不能是非数字');
          return;
        }
      }
      let volumes = 0;
      arr.forEach((value, key) => {
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        let all = (h * w * l * c) / 1000000;
        volumes = volumes + all;
      });
      this.selectionGargoInformationRow.intoStorageVolume = volumes.toFixed(
          3
      );
    },

    myGetStorageListPage() {
      //  获取仓库下拉列表
      Api.getStorageList().then((res) => {
        if (res.data.status === "success") {
          this.cangkuList = res.data.result || [];
          if (this.cangkuList.length > 0) {
            this.newForm.storageId = this.cangkuList[0].id;
          }
        } else {
          this.$message.error(`${res.data.message}--仓库下拉列表API`);
        }
      });
    },

    // 计算规格
    onComputeSpecifications () {
      let arr = this.selectionGargoInformationRow.itemSpecs;
      for (let i = 0; i < arr.length; i++) {
        const value = arr[i];
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) {
          this.$message.warning('规格的长或宽或高或件数不能留空，也不能是非数字');
          return;
        }
      }
      let newstr = "";
      arr.forEach((value, key) => {
        let h = parseFloat(value.goodsHeight);
        let w = parseFloat(value.goodsWide);
        let l = parseFloat(value.goodsLength);
        let c = parseFloat(value.packageCount);
        let str = l + "*" + w + "*" + h + "*" + c + "+";
        newstr = newstr + str;
      });
      newstr = newstr.slice(0, -1);
      this.selectionGargoInformationRow.specs = newstr;
    },

    // 规格填充（根据 specs 自动填充）
    onInputSpecifications(isReplace) {
      const specsStr = this.selectionGargoInformationRow.specs;

      if (!specsStr) {
        this.$message.warning('货物信息中的规格汇总 内容不能为空');
        return;
      }
      let indexBegin = 0;
      // 清空现有的规格列表
      if(isReplace===1) {
        this.selectionGargoInformationRow.itemSpecs.length = 0;
      }
      else{
        indexBegin = this.selectionGargoInformationRow.itemSpecs.length;
      }
      try {
        const specsArray = specsStr.split(/[+,，;；]/);;
        let hasError = false;
        let errorMessage = "";
        this.errorIndex = -1;

        for (let i = 0; i < specsArray.length; i++) {

          const spec = specsArray[i].trim();

          // 检查是否符合格式：四个数字以 * 分隔
          const regex = /^(\d+\.?\d*)\*(\d+\.?\d*)\*(\d+\.?\d*)\*(\d+\.?\d*)$/;
          const match = spec.match(regex);

          if (!match) {
            hasError = true;
            errorMessage = errorMessage + `第 ${i + 1 + indexBegin} 行格式错误：“${spec}” 不符合“长*宽*高*件数”的格式`;
            this.errorIndex = i;
            console.log('当前错误行索引:', this.errorIndex);
            // continue; // 跳过当前项，继续处理后面的项
          }

          const [_, length, width, height, count] = match;

          // 校验是否为有效数字
          const goodsLength = Number(length);
          const goodsWide = Number(width);
          const goodsHeight = Number(height);
          const packageCount = Number(count);

          if (
              isNaN(goodsLength) ||
              isNaN(goodsWide) ||
              isNaN(goodsHeight) ||
              isNaN(packageCount)
          ) {
            hasError = true;
            errorMessage = errorMessage + `第 ${i + 1 + indexBegin} 行包含非数字内容：“${spec}”; `;
            this.errorIndex = i;
            console.log('当前错误行索引:', this.errorIndex);
            // continue;
          }

          // 校验件数是否为整数
          if (!Number.isInteger(packageCount)) {
            hasError = true;
            errorMessage = errorMessage + `第 ${i + 1 + indexBegin} 行的件数必须为整数：“${spec}”; `;
            this.errorIndex = i;
            console.log('当前错误行索引:', this.errorIndex);
            // continue;
          }

          // 推入新规格项（即使前面有错误，也保留已解析成功的数据）
          this.selectionGargoInformationRow.itemSpecs.push({
            goodsName: this.selectionGargoInformationRow.itemName,
            goodsLength,
            goodsWide,
            goodsHeight,
            packageCount,
            volume: ((goodsLength * goodsWide * goodsHeight * packageCount) / 1e6).toFixed(
                3
            ),
          });
        }

        if (hasError) {
          this.$message.error(errorMessage);
          console.warn(`错误发生在第 ${this.errorIndex + 1} 行：${specsArray[this.errorIndex]}`);
        } else {
          this.$message.success("规格填充成功");
        }

        // 无论是否有错误，都重新计算体积
        this.totleVolume();
      } catch (error) {
        this.$message.error("规格解析失败，请检查输入格式");
        console.error(error);
      }
    },

    saveData() {
      // 申请打包信息
      let applyPackInfoParam = this.applyPackInfo;
      let newForm = this.newForm;
      // 处理货物
      let arrItes = JSON.parse(JSON.stringify(this.newForm)) || {};
      let oldItemArr = this.oldItemReqs;
      let newItemArr = arrItes.itemReqs;
      let subItemArr = tools.transOperationType("itemId",newItemArr,oldItemArr);
      let itemCount = subItemArr.length;
      for (var i = 0; i < subItemArr.length; i++) {
        let subItem = subItemArr[i];
        subItem.quantity = subItem.quantity || 1;
        subItem.unitPrice = subItem.unitPrice || 0;
        if (subItem.itemName === "") {
          subItemArr.splice(i, 1);
          i--;
        }
        //处理货物规格
        let subItemSpecs = subItem.itemSpecs;
        let operationType = subItem.operationType;
        if("ADD" === operationType){
          subItem.itemSpecs = tools.transOperationType("specsId",subItemSpecs,[]);
        }else if("DEL" === operationType){

        }else{
          //从oldItemArr中根据itemId===subItem.itemId过滤获取原始的货物
          const oldItem = oldItemArr.find(oldItem => oldItem.itemId === subItem.itemId);
          if(oldItem){
            //获取原始的货物规格
            let oldItemSpecs = oldItem.itemSpecs;
            //处理操作状态
            subItem.itemSpecs = tools.transOperationType("specsId",subItemSpecs,oldItemSpecs)
          }
        }
      }

      const fuJianComponent = this.$refs.domCommonFuJian;
      console.info("domCommonFuJian",fuJianComponent)
      let files = fuJianComponent.annexTable || [];
      let DELFilesList = fuJianComponent.DELFilesList || [];
      let fileLists = [...files, ...DELFilesList].map(item => ({
        fileId: item.fileId,
        fileName: item.fileName,
        operationType: item.operationType,
      }));

      let paraV2 = {
        billPackId: this.billPackId,
        intoStorageTime: this.applyPackInfo.intoStorageTime,
        storageId: this.newForm.storageId,
        isCustomerCheckScale: this.applyPackInfo.isCustomerCheckScale,
        itemReqs: subItemArr,
        files: fileLists,
      };

      paraV2.sign = tools.getSign(paraV2);
        Api.createStockBillV4(paraV2)
            .then((res) => {
              if (res.data.status === "success") {
                // this.intoStockId = res.data.result.intoStockId;
                this.$confirm("添加成功", "提示:", {
                  confirmButtonText: "继续添加",
                  cancelButtonText: "继续操作当前单据",
                })
                    .then(() => {
                      this.reload();
                    })
                    .catch(() => {
                      this.reload();
                      // this.$router.push("/DynamicList/IntoStockList");
                      this.$router.push({
                        path: "/pages/v4/intoStock/editIntoStock",
                        query: {
                          intoStockId: res.data.result.intoStockId,
                          pageType: "edit",
                        },
                      });
                    });
                // this.reload();
                // this.$router.push("/pages/v4/daHuo/daHuoList");
              }
            })
            .catch(() => {});

    },
    //入库确认
    intoStrockSureV4(row){
      this.$confirm("是否入库确认所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [this.intoStockId];
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.intoStrockSureV4(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },
    //取消入库确认
    cancelIntoStrockSureV4(){
      this.$confirm("是否取消入库确认所选入库单?", "系统提示:")
          .then((res) => {
            let ids = [this.intoStockId];
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.cancelIntoStrockSureV4(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },

    //推送复测
    pushIntoStrockCheckScale(){
      this.$confirm("是否推送复测所选入库单?", "系统提示:")
          .then((v) => {
            let ids = [this.intoStockId];
            let param = {
              intoStockIds: ids,
            };
            param.sign = this.Tools.getSign(param);
            this.$API.pushIntoStrockCheckScale(param).then((res) => {
              this.$message.success(res.data.message || "操作成功");

              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            });
          })
          .catch(() => {});
    },




    // 批量删除规格
    delSpecsMore() {
      // if (this.selectedItemIndex === -1) {
      //   // 查看的是全部规格
      //   if (!this.$refs.mytable || !this.$refs.mytable.selection || this.$refs.mytable.selection.length === 0) {
      //     this.$message.warning('请先选择要删除的规格');
      //     return;
      //   }
      //
      //   this.$confirm('确定要删除所选规格吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     const selectedRows = this.$refs.mytable.selection;
      //     // 从 allSpecifications 中过滤掉被选中的行
      //     this.allSpecifications = this.allSpecifications.filter(spec => !selectedRows.includes(spec));
      //     this.$message.success('删除成功');
      //   }).catch(() => {});
      // } else {
      // 查看的是某个货物的规格
      if (!this.$refs.mytable || !this.$refs.mytable.selection || this.$refs.mytable.selection.length === 0) {
        this.$message.warning('请先选择要移除的规格');
        return;
      }

      this.$confirm('确定要移除所选规格吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const selectedRows = this.$refs.mytable.selection;
        // 从当前货物的规格中过滤掉被选中的行
        this.selectionGargoInformationRow.itemSpecs = this.selectionGargoInformationRow.itemSpecs.filter(
            spec => !selectedRows.includes(spec)
        );
        this.$message.success('规格移除成功');
      }).catch(() => {});
      // }
    },

    //点击货物事件=>展示对应的规格
    handleRowClick(row, event, column) {
      const index = this.newForm.itemReqs.findIndex(item => item === row);
      this.selectedItemIndex = index;
      this.selectionGargoInformationRow = row;
      if(!this.selectionGargoInformationRow.itemSpecs || this.selectionGargoInformationRow.itemSpecs.length === 0){
        this.selectionGargoInformationRow.itemSpecs =[
          {
            goodsName: row.itemName, //  品名
            serialNumber: 1, //  序号
            packageCount: 1, //  件数
            goodsLength: "", //  长(cm)
            goodsWide: "", //  宽(cm)
            goodsHeight: "", //  高(cm)
            volume: "", //  体积
            weight:""
          }
        ]
      } else {
        // 同步更新所有规格的 goodsName 为当前货物品名
        this.selectionGargoInformationRow.itemSpecs.forEach(spec => {
          spec.goodsName = row.itemName;
        });
      }
    },

    //查看全部规格
    seeAllSpecs() {
      this.selectedItemIndex = -1;
    },

    highlightRowClassName({ row, rowIndex }) {
      if (rowIndex === this.selectedItemIndex) {
        return 'highlight-row';
      }
      return '';
    },

    // 添加规格
    onAddSpecsList() {
      let item = {
        goodsName: this.selectionGargoInformationRow.itemName,
        length: "",
        wide: "",
        height: "",
        packageCount: "",
        volume: "",
        weight:""
      };
      this.selectionGargoInformationRow.itemSpecs.push(item);
    },

    // 移除规格
    onDelSpecsList (idx) {
      this.selectionGargoInformationRow.itemSpecs.splice(idx, 1);
      this.updateSpecsForSelectedItem(this.selectionGargoInformationRow); // 删除后更新 specs
    },

    updateSpecsForSelectedItem(itemRow) {
      if (!itemRow || !itemRow.itemSpecs || !this.isSpecsAutoUpdate) return;

      let newstr = '';
      let totalWeight = 0;
      let totalVolume = 0;
      const specs = itemRow.itemSpecs;

      for (let i = 0; i < specs.length; i++) {
        const spec = specs[i];
        let h = parseFloat(spec.goodsHeight);
        let w = parseFloat(spec.goodsWide);
        let l = parseFloat(spec.goodsLength);
        let c = parseFloat(spec.packageCount);
        let weight = parseFloat(spec.weight);
        if (isNaN(h) || isNaN(w) || isNaN(l) || isNaN(c)) continue;

        newstr += `${l}*${w}*${h}*${c}+`;
        // 计算体积：长*宽*高*件数 / 1000000 (转换为立方米)
        if (!isNaN(h) && !isNaN(w) && !isNaN(l) && !isNaN(c)) {
          totalVolume += (h * w * l * c) / 1000000;
        }

        // 累加重量
        if (!isNaN(weight)) {
          totalWeight += weight;
        }
      }

      newstr = newstr.slice(0, -1); // 去掉最后的 "+"
      itemRow.specs = newstr;

      // 同步更新 newForm.itemReqs 中的 specs
      const index = this.newForm.itemReqs.findIndex(
          item => item === itemRow
      );
      if (index !== -1) {
        this.newForm.itemReqs[index].specs = newstr;
        this.newForm.itemReqs[index].intoStorageWeight = totalWeight > 0 ? totalWeight.toFixed(3) : '';
        this.newForm.itemReqs[index].intoStorageVolume = totalVolume > 0 ? totalVolume.toFixed(3) : '';
      }
    },

    // 复制规格
    onCopySpecsList  (idx, row) {
      // 记得解除内存的占用
      let rowrow = JSON.parse(JSON.stringify(row.row));
      this.selectionGargoInformationRow.itemSpecs.splice(
          idx,
          0,
          rowrow
      );
      this.updateSpecsForSelectedItem(this.selectionGargoInformationRow); // 删除后更新 specs
    },

    resetData(formName) {
      //  重置表单
      this.memberNickname = "";
      this.$refs[formName].resetFields();
      if (formName === "newForm") {
        this.newForm.itemReqs = [
          {
            serialNumber: 1, //  序号
            boxNo: "", //  箱号
            shippingMarkNo: "", //  唛头
            itemNameCode: "", //  物品名
            itemName: "", //  物品名称
            unitPrice: "", //  单价
            quantity: 1, //  数量
            intoStorageCount: 0, //  入库件数
            weight: "", //重量
            intoStorageWeight: "", //入库重量
            volume: "", //体积
            intoStorageVolume: "", //入库体积
            intoStorageSettlementWeight: "",
            intoStorageSettlementVolume: "",
            specs: "", //规格汇总
            itemSpecs:[
              {
                serialNumber: 1, //  序号
                packageCount: 1, //  件数
                goodsLength: "", //  长(cm)
                goodsWide: "", //  宽(cm)
                goodsHeight: "", //  高(cm)
                volume: "", //  体积
                weight:""
              }
            ]
          },
        ];
      }
    },

    //  删除类型
    delbut(index) {
      this.newForm.itemReqs.splice(index, 1);
    },

    addbtn(i) {
      //console.log(i);
      this.newForm.itemReqs.push({
        billItemId: "",
        serialNumber: 1, //  序号
        boxNo: "", //  箱号
        shippingMarkNo: "", //  唛头
        itemNameCode: "", //  物品名
        itemName: "", //  物品名称
        unitPrice: "", //  单价
        quantity: 1, //  数量
        intoStorageCount: 0, //  入库件数
        weight: "", //重量
        intoStorageWeight: "", //入库重量
        volume: "", //体积
        intoStorageVolume: "", //入库体积
        intoStorageSettlementWeight: "",
        intoStorageSettlementVolume: "",
        specs: "", //规格汇总
        itemSpecs:[
          {
            serialNumber: 1, //  序号
            packageCount: 1, //  件数
            goodsLength: "", //  长(cm)
            goodsWide: "", //  宽(cm)
            goodsHeight: "", //  高(cm)
            volume: "", //  体积
            weight:""
          }
        ]
      });
    },

    //查询运单
    onSearchWaybillNumber(){
      let waybillNumber = this.searchWaybillNumber;
      if(!waybillNumber){
        this.$message.success("运单号不能为空");
        return;
      }
      let obj = {
        conditonKey: "waybillNumber",
        conditonVal: waybillNumber,
      };
      this.$API
          .runPageReportDetails({
            number: "into_stock_search_big_goods_bill_detail",
            conditionReqs: [obj],
          })
          .then((res) => {
            let datas = res.data.result.datas || [];
            if(!datas){
              this.$message.success("查询暂无数据");
              return;
            }
            let resultData = datas[0];

            this.applyPackInfo.waybillNumber = resultData.waybillNumber;
            this.newForm.courierNumber = resultData.courierNumber;
            this.newForm.memberId = resultData.memberId;
            this.newForm.nickname = resultData.memberName;
            this.applyPackInfo.isCustomerCheckScale = resultData.isCustomerCheckScale;
            this.newForm.storageId = resultData.storageId;

            //查询货物信息
            let billPackId = resultData.billPackId;
            this.billPackId = billPackId;
            let param = {
              conditionReqs: [
                {
                  conditonKey: 'billPackId',
                  conditonVal: billPackId,
                },
              ],
              number: 'big_goods_bill_detail_packages_items',
            }
            this.$API.runReport(param).then((res) => {
              if (res.data.result) {
                let results = res.data.result.datas || []

                this.newForm.itemReqs = results.map(item => {
                  let itemReq = {
                    itemId: item.itemId, //  序号
                    serialNumber: item.serialNumber, //  序号
                    boxNo: item.boxNo, //  箱号
                    shippingMarkNo: item.shippingMarkNo, //  唛头
                    itemNameCode: item.itemNameCode, //  物品名
                    itemName: item.itemName, //  物品名称
                    unitPrice: item.unitPrice, //  单价
                    quantity: item.quantity, //  数量
                    // intoStorageCount: item.intoStorageCount, //  入库件数
                    weight: item.weight, //重量
                    // intoStorageWeight: item.intoStorageWeight, //入库重量
                    volume: item.volume, //体积
                    // intoStorageVolume: item.intoStorageVolume, //入库体积
                    // specs: item.specs, //规格汇总
                    // itemSpecs:item.itemSpecs,
                    operationType : "UPDATE",
                  };
                  return itemReq;
                });

                this.oldItemReqs = JSON.parse(JSON.stringify(this.newForm.itemReqs)) || [];
              } else {
                this.$message.error(`${res.data.message}--获取大货货物详情API`);
              }
            });

          });
    },


    //获取入库单详情
    myGetRukuBillDetail() {
      let obj = {
        conditonKey: "intoStockId",
        conditonVal: this.intoStockId,
      };
      let param = {
        conditionReqs: [obj],
        number: 'into_stock_detail',
      }
      this.$API.runReport(param).then((res) => {
        let datas = res.data.result.datas || [];
        if (!datas) {
          this.$message.success("查询暂无数据");
          return;
        }
        let resultData = datas[0];
        this.applyPackInfo.billPackId = resultData.billPackId;
        this.billPackId = resultData.billPackId;
        this.applyPackInfo.waybillNumber = resultData.waybillNumber;
        this.newForm.courierNumber = resultData.courierNumber;
        this.newForm.memberId = resultData.memberId;
        this.newForm.nickname = resultData.memberName;
        this.applyPackInfo.intoStorageTime = resultData.intoStorageTime;
        this.applyPackInfo.isCustomerCheckScale = resultData.isCustomerCheckScale;
        this.newForm.storageId = resultData.storageId;
        this.applyPackInfo.comment = resultData.comment;
      });
      //货物货物
      param = {
        conditionReqs: [obj],
        number: 'into_stock_detail_items',
      }
      this.$API.runReport(param).then((res) => {
        if (res.data.result) {
          let results = res.data.result.datas || []

          this.newForm.itemReqs = results.map(item => {
            let itemReq = {
              billItemId: item.billItemId,
              itemId: item.itemId, //  序号
              serialNumber: item.serialNumber, //  序号
              boxNo: item.boxNo, //  箱号
              shippingMarkNo: item.shippingMarkNo, //  唛头
              itemNameCode: item.itemNameCode, //  物品名
              itemName: item.itemName, //  物品名称
              unitPrice: item.unitPrice, //  单价
              quantity: item.quantity, //  数量
              intoStorageCount: item.intoStorageCount, //  入库件数
              weight: item.weight, //重量
              intoStorageWeight: item.intoStorageWeight, //入库重量
              volume: item.volume, //体积
              intoStorageVolume: item.intoStorageVolume, //入库体积
              intoStorageSettlementWeight: item.intoStorageSettlementWeight,
              intoStorageSettlementVolume: item.intoStorageSettlementVolume,
              specs: item.specs, //规格汇总
              itemSpecs:item.itemSpecs,
              operationType : "UPDATE",
            };
            return itemReq;
          });

          this.oldItemReqs = JSON.parse(JSON.stringify(this.newForm.itemReqs)) || [];
        } else {
          this.$message.error(`${res.data.message}--获取包裹详情API`);
        }
      });

      if("copyAdd" === this.pageType)
        return;
      //附件
      param = {
        conditionReqs: [obj],
        number: 'into_stock_detail_file',
      }
      this.$API.runReport(param).then((res) => {
        if (res.data.result) {
          let results = res.data.result.datas || []
          this.annexTable = results;

          console.info("获取的附件",this.annexTable)
        }
      });

    },

    btnShow(){
      return this.intoStockId !== null && this.intoStockId !== '';
    }





  },
};
</script>

<style scoped lang="scss">
.M {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 0px 4px #e0e0e0;
  padding: 20px;
  width: 99.5%;
  box-sizing: border-box;
  .M_tabel {
    /deep/ .el-input__inner:hover,
    /deep/ .el-input__inner:focus {
      border: 1px solid #f0a261 !important;
    }
    /deep/ .el-input__inner {
      text-align: center;
    }
  }
}

.formS {
  border-bottom: 1px silver solid;
  padding-bottom: 20px;
}

.tableBox {
  width: 80%;
  padding: 20px 60px;
}
.el-col-3 {
  width: 20%;
}
.member {
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}
.membertop {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0 0 0;
}
.memberbotton {
  color: #f00;
}
.inpustyle ::v-deep {
  .el-input__inner {
    height: 30px;
    padding: 0 40px;
  }
}
.Clipboard {
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
  box-sizing: border-box;
  .Clipboardtop {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-around;
  }
}

.myInputs {
  ::v-deep {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
  }
}

.radiosBox {
  padding: 0 20px;
  margin-top: 20px;
}

/deep/ .el-cascader {
  line-height: 30px !important;
}

.topBtn {
  margin-top: 10px;
}

.mainBox {
  //height: calc(100vh - 135px);
  //overflow-y: auto;
}

.displayFlex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.newForm .queryItem1 {
  margin-bottom: 14px;
}
.wtl_displayFlex {
  display: flex;
  align-items: center;
}
.wtl_displayFlex2 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.ItemServerBox {
  margin-top: 10px;
  margin-right: 30px;
}
// .serverItems {
//   margin-top: 10px;
//   margin-right: 10px;
// }
.totBtns {
  background-color: #fff;
  margin-left: 4px;
  font-size: 12px;
  background-color: #409eff;
  color: #fff;
  padding: 4px;
  border-radius: 2px;
}
.countInput {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 60px;
}
.labelNum {
  width: 40px;
}

// 去掉数字输入框上下箭头
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="‘number’"] {
  -moz-appearance: textfield !important;
}

.topbox {
  margin-top: 20px;

  ::v-deep {
    .el-checkbox-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .el-checkbox {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      min-width: 25%;
      width: 300px;
    }

    .el-checkbox__label {
      flex: 1;
      display: flex;
      align-items: center;
      //  justify-content: space-between;
    }
  }
}

.highlight-row {
  background-color: #f0c786 !important; // 聚焦背景色（如橙色）
}
.rowflexbox{
  display: flex;
  align-items: center;
  gap: 8px; // 设置按钮之间的间距
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}
.tag-container {
  //width: 100%;
  //display: flex;
  ////justify-content: flex-end;
  //justify-content: space-between; // 水平分布
  //align-items: center; // 垂直居中

  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.tag-searchWaybill {
  display: flex;
  align-items: center; // 垂直居中
  gap: 12px; // 控件之间间距
  margin-top: 15px;

  span {
    font-size: 14px;
    color: #666;
    white-space: nowrap; // 防止换行
  }

  .jy-form-input {
    width: 200px; // 可根据需要调整输入框宽度
  }
}
.billHeader ::v-deep .el-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.billHeader ::v-deep .el-col {
  flex: 1;
  max-width: calc(100% / 4); /* 平分占满一行 */
}

.billHeader .header-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.billHeader .label {
  height: 29px;
  font-size: 14px;
  min-width: 70px;
  text-align: right;
}

.billHeader .value {
  flex: 1;
  display: inline-block;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;
  font-weight: normal;
  min-height: 29px;
  line-height: 29px;
  vertical-align: middle;
  font-size: 14px;
}

.title-area {
  text-align: center;
  border-bottom: 3px solid #ff9900;
  padding-bottom: 10px;
  margin:0px 20px 0px 20px;
}

.title-area h2 {
  font-size: 24px;
  color: #333;
  margin: 0;
}

.custom-form-item ::v-deep {
  .el-form-item__label {
    border: none !important;
    background-color: transparent !important;
    padding-bottom: 0 !important;
  }

  .el-form-item__content {
    border: none !important;
    background-color: transparent !important;
    padding-bottom: 0 !important;
    //border-bottom: 1px solid #ccc !important;
    border-radius: 0 !important;
  }

  .el-select .el-input__inner {
    border: none !important;

    border-radius: 0 !important;
  }
  &:focus {
    outline: none !important;
    border-color: #ccc !important;
    box-shadow: none !important;
  }
}


</style>
